export enum SessionStatus {
    New = 'NEW',
    PreCall = 'PRE_CALL',
    WaitingForAgent = 'WAITING_FOR_AGENT',
    Calling = 'CALLING',
    ClientLeft = 'CLIENT_LEFT',
    AgentsUnavailable = 'AGENTS_UNAVAILABLE',
    AppointmentNotStarted = 'APPOINTMENT_NOT_STARTED',
    AfterHours = 'AFTER_HOURS',
    InSession = 'IN_SESSION',
    OnHold = 'ON_HOLD',
    Chatbot = 'CHATBOT',
    SessionEnded = 'SESSION_ENDED',
}
